<template>
    <div class="cell-renderer-download icon-wrapper">
      <font-awesome-icon
        class="download-icon"
        :class="iconClass"
        :icon="[iconType, icon]"
        @click="clicked"
        />
    </div>
</template>

<script>
export default {
  name: 'CellRendererDownload',
  computed: {
    iconType () {
      return this.params.iconType;
    },
    icon () {
      return this.params.icon;
    },
    iconClass() {
      const { value } = this.params;
      if (!value) {
        return 'disabled';
      }

      return 'cursor-pointer';
    },
  },
  methods: {
    clicked() {
      const { value, documentType, documentTypeId } = this.params;

      if (!value) {
        return;
      }

      const params = {
        documentType: documentType,
        documentGuid: [value],
        documentTypeId: documentTypeId,
      };

      this.$parent.$emit('download', params);
    }
  }
}
</script>

<style lang="scss">
  .cell-renderer-download {
    &.icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      .download-icon {
        font-size: 20px;
      }
      
      .disabled {
        color: #9c9c9c;
      }
    }
  }
</style>
